<template>
  <div>
    <v-card outlined>
      <!-- <h2 class="text-center colorblue">Настройка рассылки по 44 ФЗ</h2> -->
      <v-row no-gutters>
        <v-col md="6">
          <RangeSliderWithCheckers
            caption="Количество побед"
            :min="WinnersMin"
            :max="WinnersMax"
            v-model="CountWinners"
          />
          <RangeSliderWithCheckers
            caption="Сумма обеспечения исполнения контракта"
            :min="ContractMin"
            :max="ContractMax"
            v-model="ContractSumm"
          />
          <RangeSliderWithCheckers
            caption="Начальная максимальная цена контракта"
            :min="StartContractMin"
            :max="StartContractMax"
            v-model="StartContractSumm"
          />
          <!-- <v-col cols="6" sm="6" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Дата расчетов по"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отменить
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">
                  Применить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col> -->
          <v-col cols="6" sm="6" md="4" style="padding: 20px 0 0 30px">
            <v-text-field
              v-model="ratio"
              label="Коэффициент"
              type="number"
              :step="0.1"
              :max="1"
              :min="0.1"
            />
          </v-col>
          <v-row md="4" no-gutters style="padding: 0px 30px">
            <v-col cols="12" sm="12" md="4">
              <v-checkbox v-model="sending" label="Включена рассылка" />
            </v-col>
            <v-row>
              <v-col sm="12" md="6" v-if="sending"
                ><v-checkbox
                  label="Тестовая рассылка"
                  v-model="malingTest"
                  class="check"
              /></v-col>
              <v-col sm="12" md="6"
                ><v-text-field
                  v-model="testEmail"
                  label="Тестовый Email"
                  type="text"
                  :step="0.1"
                  :max="1"
                  :min="0.1"
                  v-if="malingTest && sending"
              /></v-col>
            </v-row>
          </v-row>
          <div class="btn-group">
            <v-btn color="success" @click="SaveMailWinners">
              <v-icon left> mdi-content-save </v-icon>
              Сохранить
              <loading v-if="load" />
            </v-btn>
          </div>
        </v-col>
        <!-- <v-col md="6 pd-1">
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
          <v-card style="margin-top: 1rem">
            <v-row>
              <v-col md="12" class="pd-1-2">
                <h3>
                  Количество побед: от {{ CountWinners[0] }} до
                  {{ CountWinners[1] }}
                </h3>
                <h3>
                  Сумма обеспечения исполнения контракта: от
                  {{ ContractSumm[0] }} до {{ ContractSumm[1] }}
                </h3>
                <h3>
                  Начальная максимальная цена контракта: от
                  {{ StartContractSumm[0] }} до {{ StartContractSumm[1] }}
                </h3>
              </v-col>
            </v-row>
          </v-card>
        </v-col> -->
      </v-row>
    </v-card>
  </div>
</template>

<script>
import RangeSliderWithCheckers from "../../components/RangeSliderWithChecker.vue";
import loading from "../../components/loading.vue";

export default {
  name: "fz615",
  components: { RangeSliderWithCheckers, loading },
  data: () => ({
    CountWinners: [3, 20, true],
    WinnersMin: 0,
    WinnersMax: 10000,
    ContractSumm: [40000, 3000000, true],
    ContractMin: 0,
    ContractMax: 3000000000,
    StartContractSumm: [40000, 3000000, true],
    StartContractMin: 0,
    StartContractMax: 10000000000,
    search: "",
    load: false,
    menu: null,
    date: null,
    ratio: 0,
    sending: false,
    malingTest: false,
    testEmail: "",
  }),
  methods: {
    async SaveMailWinners() {
      this.load = true;
      const obj = {
        wincol: {
          min: this.CountWinners[0],
          max: this.CountWinners[1],
          off: this.CountWinners[2],
        },
        contractSum: {
          min: this.ContractSumm[0],
          max: this.ContractSumm[1],
          off: this.ContractSumm[2],
        },
        startContractSum: {
          min: this.StartContractSumm[0],
          max: this.StartContractSumm[1],
          off: this.StartContractSumm[2],
        },
        date_to: this.date,
        ratio: this.ratio,
        sending: this.sending,
        malingTest: this.malingTest,
        testEmail: this.testEmail,
      };
      try {
        await this.$store.dispatch("SaveMailWinners615", obj);
      } finally {
        this.load = false;
      }
    },
    async LoadMailWinners() {
      this.load = true;
      try {
        const { data } = await this.$store.dispatch("LoadMailWinners615");

        //set value
        this.CountWinners = [data.wincol.min, data.wincol.max, data.wincol.off];
        this.ContractSumm = [
          data.contractSum.min,
          data.contractSum.max,
          data.contractSum.off,
        ];
        this.StartContractSumm = [
          data.startContractSum.min,
          data.startContractSum.max,
          data.startContractSum.off,
        ];
        this.date = data.date_to;
        this.ratio = data.ratio;
        this.sending = data.sending;
        this.malingTest = data.malingTest;
        this.testEmail = data.testEmail;
      } finally {
        this.load = false;
      }
    },
  },
  async mounted() {
    await this.LoadMailWinners();
  },
};
</script>

<style lang="sass">
.btn-group
  margin: 10px 20px 20px 20px
  display: flex
.pd-1
  padding: 1rem !important
.pd-1-2
  padding: 1rem 2rem !important
</style>
